import { formatCurrency } from "./reportFormat";
import { S } from "./settlementLabels";

const Cell = ({ label, value, testid }) => (
  <div className="rounded-2xl bg-background p-3 shadow-neu-in" data-testid={testid}>
    <p className="text-[10px] text-muted-foreground">{label}</p>
    <p className="font-bold">{value || "—"}</p>
  </div>
);

// بطاقة تعريف الموظف صاحب التسوية: الاسم والفرع والمسمى والراتب الأساسي والمدة والسبب.
export const SettlementSummary = ({ p, reason, lang }) => {
  const L = S[lang === "en" ? "en" : "ar"];
  const name = lang !== "en" && p.name_ar ? p.name_ar : p.user_name;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="settlement-summary">
      <Cell label={L.ident.name} value={name} testid="settle-info-name" />
      <Cell label={L.ident.job} value={p.job_title} testid="settle-info-job" />
      <Cell label={L.ident.branch} value={p.branch_name} testid="settle-info-branch" />
      <Cell label={L.ident.reason} value={L.exitTypes[reason] || L.reasons[reason] || reason} testid="settle-info-reason" />
      <Cell label={L.ident.basic} value={formatCurrency(p.basic_salary, p.currency)} testid="settle-info-basic" />
      <Cell label={L.rows.hire} value={p.hire_date} testid="settle-info-hire" />
      <Cell label={L.rows.last} value={p.last_working_day} testid="settle-info-last" />
      <Cell label={L.rows.years} value={p.years_of_service} testid="settle-info-years" />
    </div>
  );
};
